import React, { useState, useRef, useEffect } from "react";
import adminAvatar from "../assets/admin-avatar.png";
import { FaChevronDown } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // CHANGE PASSWORD ROUTE
  const handleChangePassword = () => {
    navigate("/admin/change-password");
    setOpen(false);
  };

const handleLogout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("refreshToken");

  window.location.href = "https://nanopulse.in/";
};

  return (
    <div style={styles.header}>
      <div style={styles.left}>
        <i
          className="ti-menu"
          style={styles.menuIcon}
          onClick={() => document.body.classList.toggle("sidebar-mini")}
        ></i>
      </div>

      <div style={styles.right}>
        <div
          style={styles.profile}
          onClick={() => setOpen(!open)}
          ref={dropdownRef}
        >
          <img src={adminAvatar} alt="user" style={styles.avatar} />
          <span>Admin</span>

          <FaChevronDown
            style={{
              fontSize: "10px",
              transition: "0.3s",
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />

          {open && (
            <div style={styles.dropdown}>
              <div style={styles.dropdownItem} onClick={handleChangePassword}>
                Change Password
              </div>
              <div style={styles.dropdownItem} onClick={handleLogout}>
                Logout
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};



const SIDEBAR_WIDTH = 216;

const styles = {
  header: {
    position: "fixed",
    top: 0,
    left: SIDEBAR_WIDTH,
    right: 0,
    height: "70px",
    background: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 25px",
    borderBottom: "0px solid #ddd",
    borderLeft: "4px solid #2F4050",
    zIndex: 1000,
  },

  right: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginLeft: "auto",
  },

  profile: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    cursor: "pointer",
    position: "relative",
  },

  avatar: {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    objectFit: "cover",
  },

  dropdown: {
    position: "absolute",
    top: "45px",
    right: 0,
    background: "#fff",
    border: "1px solid #ddd",
    borderRadius: "6px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    width: "180px",
    zIndex: 1000,
  },

  dropdownItem: {
    padding: "10px 15px",
    cursor: "pointer",
    borderBottom: "1px solid #eee",
  },

};

export default Header;